var _rect, _path, _rect2, _rect3, _rect4, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-2926 -2968H4201V-2998H-2926V-2968ZM4188 -2981V2878H4218V-2981H4188ZM4201 2865H-2926V2895H4201V2865ZM-2913 2878V-2981H-2943V2878H-2913ZM-2926 2865C-2918.82 2865 -2913 2870.82 -2913 2878H-2943C-2943 2887.39 -2935.39 2895 -2926 2895V2865ZM4188 2878C4188 2870.82 4193.82 2865 4201 2865V2895C4210.39 2895 4218 2887.39 4218 2878H4188ZM4201 -2968C4193.82 -2968 4188 -2973.82 4188 -2981H4218C4218 -2990.39 4210.39 -2998 4201 -2998V-2968ZM-2926 -2998C-2935.39 -2998 -2943 -2990.39 -2943 -2981H-2913C-2913 -2973.82 -2918.82 -2968 -2926 -2968V-2998Z",
    fill: "#FF0000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 900,
    transform: "translate(-342 -690)",
    fill: "#17171F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 257,
    height: 52,
    transform: "translate(-12 -12)",
    fill: "#434343"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    stroke: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9231 8H8.07692C7.79131 8 7.51739 8.11346 7.31542 8.31542C7.11346 8.51739 7 8.79131 7 9.07692V18.7692C7 19.0548 7.11346 19.3288 7.31542 19.5307C7.51739 19.7327 7.79131 19.8462 8.07692 19.8462H19.9231C20.2087 19.8462 20.4826 19.7327 20.6846 19.5307C20.8865 19.3288 21 19.0548 21 18.7692V9.07692C21 8.79131 20.8865 8.51739 20.6846 8.31542C20.4826 8.11346 20.2087 8 19.9231 8ZM19.9231 9.07692V15.9928L18.1684 14.2387C18.0684 14.1387 17.9496 14.0594 17.819 14.0052C17.6883 13.9511 17.5482 13.9232 17.4068 13.9232C17.2653 13.9232 17.1253 13.9511 16.9946 14.0052C16.8639 14.0594 16.7452 14.1387 16.6452 14.2387L15.299 15.5849L12.3375 12.6234C12.1356 12.4216 11.8617 12.3082 11.5762 12.3082C11.2908 12.3082 11.0169 12.4216 10.815 12.6234L8.07692 15.3614V9.07692H19.9231ZM8.07692 16.8846L11.5769 13.3846L16.9615 18.7692H8.07692V16.8846ZM19.9231 18.7692H18.4847L16.0616 16.3462L17.4078 15L19.9231 17.516V18.7692ZM15.0769 12.0385C15.0769 11.8787 15.1243 11.7226 15.213 11.5897C15.3018 11.4569 15.4279 11.3534 15.5755 11.2923C15.7231 11.2311 15.8855 11.2151 16.0422 11.2463C16.1989 11.2775 16.3428 11.3544 16.4557 11.4673C16.5687 11.5803 16.6456 11.7242 16.6768 11.8809C16.708 12.0376 16.692 12.2 16.6308 12.3476C16.5697 12.4951 16.4662 12.6213 16.3333 12.71C16.2005 12.7988 16.0444 12.8462 15.8846 12.8462C15.6704 12.8462 15.465 12.7611 15.3135 12.6096C15.162 12.4581 15.0769 12.2527 15.0769 12.0385Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/image_icon.79cf783ce7d1ed7f8c8c5d37bc833a7d.svg";
export { ForwardRef as ReactComponent };